module.exports = __webpack_public_path__ + "img/listeProduitsHM.a9bd531d.png";